// extracted by mini-css-extract-plugin
module.exports = {"so5hssl":"so5hssl","h1xwgqmj":"h1xwgqmj"};